module.exports = __webpack_public_path__ + "static/media/BankCategory.94869b8e.pdf";